import { FrontendTemplate } from '@/types/customElementProps.types'
import type { Component } from 'vue'
import LoginView from '@/views/LoginView.vue'
import ResetPasswordView from '@/views/ResetPasswordView.vue'
import ErrorView from '@/views/ErrorView.vue'
import InfoView from '@/views/InfoView.vue'
import UpdatePasswordView from '@/views/UpdatePasswordView.vue'
import VerifyEmailView from '@/views/VerifyEmailView.vue'
import LoginExpiredView from '@/views/LoginExpiredView.vue'
import SAMLRedirectView from '@/views/SAMLRedirectView.vue'
import UpdateProfileView from '@/views/UpdateProfileView.vue'
import IdpLinkEmailView from '@/views/IdpLinkEmailView.vue'
import IdpLinkConfirmView from '@/views/IdpLinkConfirmView.vue'
import RegisterView from '@/views/RegisterView.vue'

// This is not a URL router but a template router:
// It maps what is passed as "template" property to the custom element to a view
// instead of mapping an URL to a view.
const router: Record<FrontendTemplate, Component> = {
  [FrontendTemplate.LOGIN]: LoginView,
  [FrontendTemplate.ERROR]: ErrorView,
  [FrontendTemplate.INFO]: InfoView,
  [FrontendTemplate.LOGIN_VERIFY_EMAIL]: VerifyEmailView,
  [FrontendTemplate.LOGIN_UPDATE_PASSWORD]: UpdatePasswordView,
  [FrontendTemplate.LOGIN_RESET_PASSWORD]: ResetPasswordView,
  [FrontendTemplate.LOGIN_PAGE_EXPIRED]: LoginExpiredView,
  [FrontendTemplate.LOGIN_UPDATE_PROFILE]: UpdateProfileView,
  [FrontendTemplate.LOGIN_IDP_LINK_EMAIL]: IdpLinkEmailView,
  [FrontendTemplate.LOGIN_IDP_LINK_CONFIRM]: IdpLinkConfirmView,
  [FrontendTemplate.SAML_POST_FORM]: SAMLRedirectView,
  [FrontendTemplate.REGISTER]: RegisterView,
}

export default router
